<div class="send-options-container flex column gap-16">
  <div
    class="send-option-card card-0 card-hover flex full-width align-items-center justify-content-between p-16 cursor-pointer"
    (click)="kaspaClick.emit()"
  >
    <div class="send-option-card__info flex align-items-center gap-16">
      <krc20-token-logo [ticker]="'KAS'" [size]="'lg'" />
      <div class="flex column gap-4">
        <div class="text-gray-90 typo-text-2">Kaspa</div>
        <div class="text-gray-60 typo-text-1">
          Send KAS to another wallet address
        </div>
      </div>
    </div>
  </div>

  <div
    class="send-option-card card-0 card-hover flex full-width align-items-center justify-content-between p-16 cursor-pointer"
    (click)="krc20Click.emit()"
  >
    <div class="send-option-card__info flex align-items-center gap-16">
      <krc20-token-logo [ticker]="'KRC20'" [size]="'lg'" />
      <div class="flex column gap-4">
        <div class="text-gray-90 typo-text-2">KRC20 tokens</div>
        <div class="text-gray-60 typo-text-1">
          Send KRC20 tokens to another wallet address
        </div>
      </div>
    </div>
  </div>

  <div
    class="send-option-card card-0 card-hover flex full-width align-items-center justify-content-between p-16 cursor-pointer"
    (click)="nftClick.emit()"
  >
    <div class="send-option-card__info flex align-items-center gap-16">
      <krc20-token-logo [ticker]="'NFT'" [size]="'lg'" />
      <div class="flex column gap-4">
        <div class="text-gray-90 typo-text-2">NFT</div>
        <div class="text-gray-60 typo-text-1">
          Send NFT/KRC721 to another wallet address
        </div>
      </div>
    </div>
  </div>

  <div
    class="send-option-card card-0 card-hover flex full-width align-items-center justify-content-between p-16 cursor-pointer"
    (click)="knsClick.emit()"
  >
    <div class="send-option-card__info flex align-items-center gap-16">
      <krc20-token-logo [ticker]="'KNS'" [size]="'lg'" />
      <div class="flex column gap-4">
        <div class="text-gray-90 typo-text-2">KNS</div>
        <div class="text-gray-60 typo-text-1">
          Send KNS domains or text inscriptions to another wallet address
        </div>
      </div>
    </div>
  </div>
</div>
